/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath, getApiV2Url } from '../../store-helpers';

const state = {
  tenants: [],
  limit: 20,
};
const getters = {
  tenants: state => state.tenants,
  limit: state => state.limit,
  keywordFilter: state => state.keywordFilter,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    let keyword = '';
    let withTrash = '';
    const orderBy = payload.orderBy ? `&orderBy=${payload.orderBy}` : '';
    if (payload.keyword) {
      commit(mTypes.SET_KEYWORD_FILTER, payload.keyword);
      keyword = `&q=${payload.keyword.replace(/[^a-zA-Z0-9]/g, '')}`;
    }
    if (payload.withTrash) {
      withTrash = '&withTrash=1';
    }
    return Vue.http.get(`${getApiPath(payload.user)}/partners/list?${keyword}${limit}${orderBy}${withTrash}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch partners');
      });
  },
  list({ commit }, payload) {

    //TODO: this statement is for compatibility with old versions of call of this action
    // and should be removed when disappear old type calls
    const reqUrl = payload.user
      ? `${getApiPath(payload.user)}/partners?limit=2000` // old version
      : `${getApiV2Url()}/${payload.role}/${payload.id}/partners`

    return Vue.http.get(reqUrl)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch partners');
      });
  },
  autocomplete({ commit }, payload) {
    const landlordId = payload.landlordId;
    return Vue.http.get(`${getApiPath(payload.user)}/partners/list/autocomplete?landlord_id=${landlordId}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch partners');
      });
  },
  filter({ commit }, payload) {
    const limit = `&limit=${state.limit}`;
    Vue.http.get(`${process.env.BACKEND_API_URL}api/filter/landlord/${payload.user.data.landlord_id}/partners/?keyword=${payload.keyword.trim()}${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response.data);
      });
  },
  fetchReport({}, payload) {
    let productId = '';
    let tenantId = '';
    if (payload.data.productId) {
      productId = `&productId=${encodeURIComponent(payload.data.productId)}`;
    }
    if (payload.data.tenantId) {
      tenantId = `&tenantId=${encodeURIComponent(payload.data.tenantId)}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/partners/report?${productId}${tenantId}`, { data: payload.data });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, tenants) {
    state.tenants = tenants.data;
  },
  [mTypes.EDIT_DATA](state, updatedTenant) {
    const index = state.tenants.items.findIndex(obj => obj.id === updatedTenant.id);
    if (index !== -1) {
      state.tenants.items[index].name = updatedTenant.name;
      state.tenants.items[index].address = updatedTenant.address;
    } else {
      updatedTenant.issued = 0;
      updatedTenant.total = 0;
      state.tenants.items.unshift(updatedTenant);
      state.tenants.total += 1;
    }
  },
  [mTypes.DATA_FETCHED](state, tenants) {
    state.tenants = tenants.data;
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.REMOVE_DATA](state, tenantId) {
    const index = state.tenants.items.findIndex(obj => obj.id === tenantId);
    state.tenants.items.splice(index, 1);
    state.tenants.total -= 1;
  },
  [mTypes.UPDATE_PRODUCT](state, payload) {
    const tI = state.tenants.items.findIndex(obj => obj.id === payload.tenant);
    state.tenants.items[tI].total = payload.amount;
  },
  [mTypes.ADD_PRODUCT](state, payload) {
    const tI = state.tenants.items.findIndex(obj => obj.id === payload.tenant);
    state.tenants.items[tI].total = payload.amount;
  },
  [mTypes.CLEAR_STATE](state) {
    state.tenants = [];
  },
  [mTypes.SET_KEYWORD_FILTER](state, keywordFilter) {
    state.keywordFilter = keywordFilter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/tenants.js